import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import { ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import {
  locksRequestError,
  locksRequestMade,
  locksRequestSuccess,
} from '../actionCreators/apiActions';

const fetchLockData = (teamGuid: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
) => {
  try {
    dispatch(locksRequestMade());
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/locking`,
    );

    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.GET_LOCK_DATA);
    }
    const data = await response.json();
    dispatch(
      locksRequestSuccess({
        ...data,
        teamGuid,
      }),
    );
  } catch (error) {
    dispatch(locksRequestError());
    throw error;
  }
};

export default fetchLockData;
